import { inject, Injector } from "@angular/core";
import { firstValueFrom } from "rxjs";

import { FeatureFlagName } from "../constants/feature-flags.constant";
import { FeatureFlagFacade } from "../facades/feature-flag.facade";

export interface InjectLoadedFeatureFlagOptions {
    defaultValue?: boolean;
    injector?: Injector;
}

/**
 * Return a Promise that reflects a feature-flag value
 *
 * This is useful when the actual (loaded) value must be read.
 *
 * @see injectFeatureFlag
 */
export function injectLoadedFeatureFlag(
    flagName: FeatureFlagName,
    { defaultValue, injector }: InjectLoadedFeatureFlagOptions = {},
): Promise<boolean> {
    const facade = injector
        ? injector.get(FeatureFlagFacade)
        : inject(FeatureFlagFacade);

    return typeof defaultValue === "boolean"
        ? firstValueFrom(facade.isActivated(flagName), { defaultValue })
        : firstValueFrom(facade.isActivated(flagName));
}
